import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Search, ShoppingBag, User } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export const Navigation = () => {
  const links = ['THE MASK', 'BUILD', 'ARSENAL', 'BUNDLES', 'INTEL', 'CONTACT'];
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);
  const [cartCount, setCartCount] = useState(0);
  const [cartUrl, setCartUrl] = useState<string | null>(null);
  const lastScrollY = useRef(0);
  useEffect(() => {
    const handlePriceUpdate = (e: any) => {
      const {
        qty,
        activeBundle,
        totalAddons,
        cartUrl
      } = e.detail;
      const maskCount = activeBundle ? activeBundle.count : qty;
      setCartCount(maskCount + totalAddons);
      setCartUrl(cartUrl);
    };
    window.addEventListener('priceUpdate', handlePriceUpdate);
    return () => window.removeEventListener('priceUpdate', handlePriceUpdate);
  }, []);
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);
      // Always show at the very top
      if (y < 80) {
        setVisible(true);
      } else if (y > lastScrollY.current + 5) {
        // Scrolling down → hide
        setVisible(false);
        if (open) setOpen(false);
      } else if (y < lastScrollY.current - 5) {
        // Scrolling up → show
        setVisible(true);
      }
      lastScrollY.current = y;
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [open]);
  return <AnimatePresence data-id="element-1201" data-mp="158yetmycg3jm">
      {visible && <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className={`fixed top-[36px] w-full z-40 transition-[height,background,border,box-shadow] duration-300 ${scrolled ? 'h-[68px] bg-base-black/95 border-b border-acid-green/15 shadow-[0_4px_30px_rgba(0,0,0,0.6)]' : 'h-[84px] bg-base-black/80 border-b border-acid-green/5'} backdrop-blur-[20px] flex items-center justify-between px-4 md:px-10`} data-id="element-1202" data-mp="1a68514tk4j8i">
          {/* Logo */}
          <a href="#" className="flex items-center group shrink-0" data-id="element-1203" data-mp="zd8vwveff3ol">
            <img src="https://cdn.magicpatterns.com/uploads/gtew43sgjbWAUi8V7My12k/hf_20260505_154603_f5f185ee-8480-4693-8c47-91f27540bf0d.png" alt="Blackout Unit" className={`w-auto object-contain transition-all duration-300 group-hover:scale-105 ${scrolled ? 'h-12' : 'h-14 md:h-16'}`} data-id="element-1204" data-mp="1d4x5aqxaje1v" />
          </a>

          {/* Desktop Links - centered */}
          <div className="hidden lg:flex items-center gap-10 font-barlow font-bold text-[11px] tracking-[3px] text-text-body absolute left-1/2 -translate-x-1/2" data-id="element-1205" data-mp="3owkmmydgypc1">
            {links.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className="hover:text-white transition-colors relative group py-2" data-id="element-1206" data-mp="1zffbpec140e3">
                {link}
                <span className="absolute -bottom-0.5 left-0 w-0 h-[1px] bg-acid-green group-hover:w-full transition-all duration-300" data-id="element-1207" data-mp="1pn9iy2dydexu"></span>
              </a>)}
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-1 sm:gap-2" data-id="element-1208" data-mp="1kqiuorrzvd1c">
            <button aria-label="Search" className="hidden sm:flex w-10 h-10 items-center justify-center text-text-body hover:text-acid-green transition-colors" data-id="element-1209" data-mp="1knwpuzwhnbmt">
              <Search size={18} strokeWidth={1.5} data-id="element-1210" data-mp="1brfebvk7pbqj" />
            </button>

            <button aria-label="Account" className="hidden sm:flex w-10 h-10 items-center justify-center text-text-body hover:text-acid-green transition-colors" data-id="element-1211" data-mp="314sklqbvx9ua">
              <User size={18} strokeWidth={1.5} data-id="element-1212" data-mp="160ktamigr4ma" />
            </button>

            <button aria-label="Cart" onClick={() => {
          if (cartUrl) {
            trackAddToCart();
            window.location.href = cartUrl;
          } else {
            document.getElementById('the-mask')?.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} className="relative w-10 h-10 flex items-center justify-center text-text-body hover:text-acid-green transition-colors group" data-id="element-1213" data-mp="111rl99ly45ti">
              <ShoppingBag size={20} strokeWidth={1.5} data-id="element-1214" data-mp="dacjbhy2zqis" />
              {cartCount > 0 && <motion.span key={cartCount} initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-acid-green text-black font-barlow font-bold text-[10px] tracking-tighter rounded-full flex items-center justify-center group-hover:bg-white transition-colors" data-id="element-1215" data-mp="9coglsq5ctgc">
                  {cartCount}
                </motion.span>}
            </button>

            <span className="hidden sm:block w-px h-6 bg-acid-green/15 mx-2" data-id="element-1216" data-mp="2oz8yhg7fzp4v"></span>

            <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
          behavior: 'smooth'
        })} className="hidden sm:block bg-acid-green text-black font-barlow font-bold text-[11px] tracking-[3px] px-5 py-3 clip-diagonal hover:bg-white transition-colors" data-id="element-1217" data-mp="1sat6ldgv13ol">
              DEPLOY NOW
            </button>

            <button onClick={() => setOpen(!open)} aria-label="Toggle menu" className="lg:hidden w-10 h-10 flex items-center justify-center text-acid-green ml-1" data-id="element-1218" data-mp="19is1htdhsh6q">
              {open ? <X size={22} data-id="element-1219" data-mp="2bwg2jzquammr" /> : <Menu size={22} data-id="element-1220" data-mp="2bwy8jo3b0f7v" />}
            </button>
          </div>

          {/* Mobile Drawer */}
          {open && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="lg:hidden absolute top-full left-0 w-full bg-[#050505] border-b border-acid-green/15 py-4 px-6 flex flex-col shadow-2xl" data-id="element-1221" data-mp="2qkb0bujpfh6p">
              {links.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} onClick={() => setOpen(false)} className="font-barlow font-bold text-sm tracking-[3px] text-text-body hover:text-acid-green transition-colors py-3 border-b border-dark-3" data-id="element-1222" data-mp="26y4xe2bhp0av">
                  {link}
                </a>)}
              <div className="flex items-center gap-3 mt-5" data-id="element-1223" data-mp="3lsv0ccfujtw6">
                <button className="flex-1 flex items-center justify-center gap-2 border border-dark-3 text-text-body py-3 font-barlow font-bold text-xs tracking-[3px]" data-id="element-1224" data-mp="3qu28wdptcx3w">
                  <Search size={14} data-id="element-1225" data-mp="3bymm8trkc3hj" /> SEARCH
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 border border-dark-3 text-text-body py-3 font-barlow font-bold text-xs tracking-[3px]" data-id="element-1226" data-mp="3gvv38r0z61h7">
                  <User size={14} data-id="element-1227" data-mp="dew6bgcfqilb" /> ACCOUNT
                </button>
              </div>
              <button onClick={() => {
          setOpen(false);
          document.getElementById('the-mask')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="mt-4 bg-acid-green text-black font-barlow font-bold text-xs tracking-[3px] py-4 clip-diagonal w-full" data-id="element-1228" data-mp="3uvnucngeyjpp">
                DEPLOY NOW
              </button>
            </motion.div>}
        </motion.nav>}
    </AnimatePresence>;
};